import jQuery from 'jquery';
import slick from 'slick-carousel';
import 'magnific-popup';

export const initGallerySlider = () => {
	jQuery(() => {
		jQuery('.js-slider-for').slick({
			rows: 0,
			slidesToShow: 1,
			slidesToScroll: 1,
			fade: true,
			asNavFor: '.js-slider-nav',
			responsive: [
				{
					breakpoint: 768,
					settings: {
						arrows: false,
						dots: true,
					},
				},
			],
		});

		jQuery('.js-slider-nav').slick({
			rows: 0,
			slidesToShow: 2,
			slidesToScroll: 1,
			asNavFor: '.js-slider-for',
			arrows: false,
			vertical: true,
			focusOnSelect: true,
		});


		jQuery('.js-popup-gallery').magnificPopup({
			delegate: 'a',
			type: 'image',
			tLoading: 'Loading image #%curr%...',
			mainClass: 'mfp-img-mobile',
			gallery: {
				enabled: true,
				navigateByImgClick: true,
				preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
			},
			image: {
				tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
			},
		});
	});
};
